(() => {
  const i18n = window.MayLondonI18n;
  const { t } = i18n;
  if (window.MayLondonSearch) return;
  window.MayLondonSearch = true;
  const config = JSON.parse(document.getElementById('MayLondonConfig')?.textContent || '{}');
  const instances = new Map();
  const money = (value) => i18n.money(Number(value) * 100);
  function init(scope = document) {
    scope.querySelectorAll('[data-predictive-search]').forEach((host) => {
      if (instances.has(host)) return;
      const input = host.querySelector('[data-predictive-input]');
      const results = host.querySelector('[data-predictive-results]');
      const status = host.querySelector('[data-predictive-status]');
      const empty = host.querySelector('[data-predictive-empty]');
      const staticResults = host.closest('.search-main')?.querySelector('[data-static-search-results]');
      const browse = host.closest('[data-search-modal]')?.querySelector('[data-search-browse]');
      const events = new AbortController();
      let request, timer, trackingTimer, sequence = 0, active = -1;
      const close = () => { results.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; };
      const run = async () => {
        const query = input.value.trim();
        const version = ++sequence;
        request?.abort();
        active = -1; input.removeAttribute('aria-activedescendant');
        if (browse) browse.hidden = !!query;
        if (!query) { close(); empty.hidden = true; status.textContent = ''; host.removeAttribute('aria-busy'); if (staticResults) staticResults.hidden = false; return; }
        request = new AbortController();
        status.textContent = t('searching'); host.setAttribute('aria-busy', 'true');
        const params = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '8', 'resources[options][fields]': 'title,product_type,variants.title,tag,vendor', 'resources[options][unavailable_products]': 'last' });
        try {
          let products, alternative = false, partial = false;
          const E = window.MayLondonStyleEngine, C = window.MayLondonStyleCatalog;
          if (host.dataset.searchCatalog && E && C) {
            const data = await C.catalogue(host.dataset.searchCatalog);
            if (data.currency !== config.currency) throw new Error(t('search_error'));
            const selection = E.collection(data.products,{query});
            alternative = selection.relaxed.length > 0; partial = !data.complete;
            products = selection.items.slice(0,8).map(product => {
              const variant = E.queryScore(product,query).variant;
              return {...product,url:product.url+(variant?'?variant='+encodeURIComponent(variant.id):''),image:variant?.image||product.image,price:(variant?.price??E.price(product))/100};
            });
          } else {
            const response = await fetch(`${i18n.route('search/suggest.json')}?${params}`, { signal: AbortSignal.any([request.signal, AbortSignal.timeout(10000)]), headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error(t('search_error'));
            const data = await response.json(); products = data.resources?.results?.products || [];
          }
          if (version !== sequence) return;
          results.replaceChildren();
          products.forEach((product, index) => {
            const url = new URL(product.url, location.origin);
            if (url.origin !== location.origin) return;
            const link = document.createElement('a'); link.className = 'predictive-result'; link.href = i18n.route(url.pathname + url.search);
            link.id = `${results.id}-${index}`; link.setAttribute('role', 'option'); link.setAttribute('aria-selected', 'false');
            const imageURL = product.featured_image?.url || product.image;
            if (imageURL) {
              try {
                const src = new URL(imageURL, location.origin);
                if (src.origin !== location.origin && src.hostname !== 'cdn.shopify.com') throw new Error();
                if (!['https:', 'http:'].includes(src.protocol)) throw new Error();
                const wrap = document.createElement('span'); wrap.className = 'product-photo';
                const img = document.createElement('img'); src.searchParams.set('width', '360'); img.src = src.href; img.alt = ''; img.width = 180; img.height = 240; img.loading = 'lazy';
                const mark = document.createElement('span'); mark.className = 'product-watermark'; mark.setAttribute('aria-hidden', 'true'); wrap.append(img, mark); link.append(wrap);
              } catch (_) { /* Invalid media must not become an external request. */ }
            }
            const copy = document.createElement('span'); copy.textContent = product.title;
            const price = document.createElement('small'); price.textContent = money(product.price);
            if (Number(product.compare_at_price_max) > Number(product.price)) { const original = document.createElement('s'); original.textContent = money(product.compare_at_price_max); price.prepend(original, ' '); const sale = document.createElement('span'); sale.className = 'search-tile__sale'; sale.textContent = t('sale'); link.querySelector('.product-photo')?.append(sale); }
            copy.append(price); link.append(copy); results.append(link);
          });
          const count = results.children.length;
          results.hidden = count === 0; empty.hidden = count > 0;
          input.setAttribute('aria-expanded', String(count > 0));
          status.textContent = count ? t('suggested', {}, count) : t('no_products');
          if (alternative) status.textContent = host.dataset.searchAlternatives + ' ' + status.textContent;
          if (partial) status.textContent += ' ' + host.dataset.searchPartial;
          if (staticResults) staticResults.hidden = true;
          clearTimeout(trackingTimer);
          trackingTimer = setTimeout(() => window.MayLondonTrack?.('search', { search_term: query, key: `search-${query.toLowerCase()}` }), 700);
        } catch (error) {
          if (error.name !== 'AbortError' && version === sequence) { close(); status.textContent = i18n.message(error, 'search_error'); if (staticResults) staticResults.hidden = false; }
        } finally { if (version === sequence) host.removeAttribute('aria-busy'); }
      };
      input.addEventListener('input', () => {
        ++sequence; request?.abort(); clearTimeout(timer); clearTimeout(trackingTimer);
        close(); empty.hidden = true; timer = setTimeout(run, 160);
      }, { signal: events.signal });
      input.addEventListener('keydown', (event) => {
        const links = [...results.children];
        if (event.key === 'Escape') { close(); return; }
        if (results.hidden || !links.length) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault(); active = (active + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
          links.forEach((link, i) => link.setAttribute('aria-selected', String(i === active)));
          input.setAttribute('aria-activedescendant', links[active].id); links[active].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Enter' && active >= 0) { event.preventDefault(); location.assign(links[active].href); }
      }, { signal: events.signal });
      host.querySelector('form').addEventListener('submit', () => window.MayLondonTrack?.('search', { search_term: input.value.trim(), key: `search-${input.value.trim().toLowerCase()}` }), { signal: events.signal });
      instances.set(host, () => { events.abort(); request?.abort(); clearTimeout(timer); clearTimeout(trackingTimer); });
      if (staticResults && input.value.trim()) run();
    });
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => instances.forEach((dispose, host) => { if (event.target.contains(host)) { dispose(); instances.delete(host); } }));
  init();
})();
